$(function () {
  tech.lazyLoad.initLazyLoad('.lazyBackground');
  tech.lazyLoad.initLazyLoad('video.lazy');
  tech.lazyLoad.initLazyLoad('.anim-trigger');
  tech.lazyLoad.initLazyLoad('.swiper-container');
});